const HTTP_VERSION_SUFFIX_PATTERN = /HTTP\/\d+(?:\.\d+)?(?:\s.*)?$/i;
const MUSTACHE_ROUTE_PARAM_PATTERN = /\{\{\s*([A-Za-z_][A-Za-z0-9_-]*)\s*\}\}/g;
const ANGLE_ROUTE_PARAM_PATTERN =
  /<([A-Za-z_][A-Za-z0-9_-]*)(?:>|(?=$|[/?#]))/g;
const UNTERMINATED_BRACE_ROUTE_PARAM_PATTERN =
  /\{([A-Za-z_][A-Za-z0-9_-]*)(?=$|[/?#])/g;
const ROUTE_PARAM_DASH_PATTERN = /-/g;

export const decodeUriComponentSafely = (value: string): string => {
  try {
    return decodeURIComponent(value);
  } catch {
    return value;
  }
};

export const withLiteralRouteParamBraces = (url: string): string =>
  url.replaceAll(/%7B/gi, '{').replaceAll(/%7D/gi, '}');

const normalizeRouteParamName = (name: string): string =>
  name.replace(ROUTE_PARAM_DASH_PATTERN, '_');

export const normalizeEndpointCandidateUrl = (value: string): string =>
  decodeUriComponentSafely(value)
    .replace(HTTP_VERSION_SUFFIX_PATTERN, '')
    .replace(
      MUSTACHE_ROUTE_PARAM_PATTERN,
      (_match: string, name: string) => `{${normalizeRouteParamName(name)}}`,
    )
    .replace(
      ANGLE_ROUTE_PARAM_PATTERN,
      (_match: string, name: string) => `{${normalizeRouteParamName(name)}}`,
    )
    .replace(
      UNTERMINATED_BRACE_ROUTE_PARAM_PATTERN,
      (_match: string, name: string) => `{${normalizeRouteParamName(name)}}`,
    )
    .trim();
